import { SchedulingFrequency } from '../../../types';
import { guardNumberPositive } from '../../../utils/guardNumber';
export default function schedulingToDto(values) {
    var _a, _b, _c, _d;
    switch (values.frequency) {
        case SchedulingFrequency.Manual:
            return { schedulePeriod: SchedulingFrequency.Manual };
        case SchedulingFrequency.Hours:
            return {
                schedulePeriod: SchedulingFrequency.Hours,
                scheduleFrequency: guardNumberPositive(values.interval),
            };
        case SchedulingFrequency.Days:
            return {
                schedulePeriod: SchedulingFrequency.Days,
                scheduleFrequency: guardNumberPositive(values.interval),
                scheduleTime: (_a = values.time) !== null && _a !== void 0 ? _a : '00:00:00.000Z',
            };
        case SchedulingFrequency.Weeks:
        default:
            return {
                schedulePeriod: SchedulingFrequency.Weeks,
                scheduleFrequency: guardNumberPositive(values.interval),
                scheduleTime: (_b = values.time) !== null && _b !== void 0 ? _b : '00:00:00.000Z',
                weekDays: (_d = (_c = values.weekdays) === null || _c === void 0 ? void 0 : _c.map(function (_a) {
                    var value = _a.value;
                    return value;
                })) !== null && _d !== void 0 ? _d : [],
            };
    }
}
